import React from 'react';
import {
  Crop, SlidersHorizontal, Pencil, Sticker,
  ChevronLeft, ChevronRight
} from 'lucide-react';

const SIDEBAR_ITEMS = [
  { id: 'crop', icon: Crop, label: 'Rogner' },
  { id: 'adjust', icon: SlidersHorizontal, label: 'Affiner' },
  { id: 'annotate', icon: Pencil, label: 'Annoter' },
  { id: 'stickers', icon: Sticker, label: 'Autocollants' },
];

const STICKERS = [
  { id: 'danger', emoji: '⚠️', label: 'Danger' },
  { id: 'water', emoji: '💧', label: 'Infiltration' },
  { id: 'repair', emoji: '🔧', label: 'Réparation' },
  { id: 'critical', emoji: '❗', label: 'Zone critique' },
  { id: 'crack', emoji: '🔨', label: 'Fissure' },
  { id: 'mold', emoji: '🟤', label: 'Moisissure' },
];

export default function Sidebar({ activeMode, onModeChange, onStickerSelect, collapsed, onToggleCollapse }) {
  const [showStickers, setShowStickers] = React.useState(false);

  const handleClick = (id) => {
    if (id === 'stickers') {
      setShowStickers((v) => !v);
      onModeChange('sticker');
      return;
    }
    setShowStickers(false);
    onModeChange(id);
  };

  return (
    <div className={`flex flex-col bg-gray-900 text-white transition-all duration-200 ${collapsed ? 'w-12' : 'w-14 md:w-16'} shrink-0 relative z-10`}>
      {/* Toggle */}
      <button
        onClick={onToggleCollapse}
        className="p-2 hover:bg-gray-700 flex items-center justify-center"
        title={collapsed ? 'Ouvrir' : 'Fermer'}
      >
        {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
      </button>

      {/* Actions */}
      <div className="flex flex-col gap-1 py-2">
        {SIDEBAR_ITEMS.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            onClick={() => handleClick(id)}
            className={`flex flex-col items-center justify-center p-2 rounded-lg mx-1 transition-colors text-[10px] gap-0.5
              ${activeMode === id || (id === 'stickers' && activeMode === 'sticker')
                ? 'bg-blue-600 text-white'
                : 'hover:bg-gray-700 text-gray-300'
              }`}
            title={label}
          >
            <Icon size={18} />
            {!collapsed && <span className="leading-tight">{label}</span>}
          </button>
        ))}
      </div>

      {/* Sticker picker */}
      {showStickers && !collapsed && (
        <div className="absolute left-full top-20 ml-1 bg-gray-800 rounded-lg shadow-xl p-2 w-36 z-50">
          <p className="text-xs font-semibold mb-2 text-gray-400 px-1">Autocollants</p>
          <div className="grid grid-cols-2 gap-1">
            {STICKERS.map((s) => (
              <button
                key={s.id}
                onClick={() => { onStickerSelect(s); setShowStickers(false); }}
                className="flex flex-col items-center p-2 rounded hover:bg-gray-700 text-xs"
                title={s.label}
              >
                <span className="text-xl">{s.emoji}</span>
                <span className="text-[9px] text-gray-400 mt-0.5">{s.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
